export default "__VITE_ASSET__4a9f8433__"